<!-- 
  -- Projet: Gestion des stagiaires
  -- Auteur : Tim Allemann
  -- Date : 16.09.2020
  -- Description : Formulaire de modification d'un contact
  -- Fichier : EditContact.vue
  -->

<template>
  <v-row justify="center">
    <v-form ref="formEditContact" v-model="validEditContact" lazy-validation>
      <v-dialog v-model="dialog" max-width="600px">
        <template v-slot:activator="{ on, attrs }">
          <v-btn color="success" dark v-bind="attrs" v-on="on" text fab>
            <v-icon color="blue">
              mdi-pencil
            </v-icon>
          </v-btn>
        </template>
        <v-card>
          <v-card-title>
            <span class="headline">Modifier un dernier contact</span>
          </v-card-title>
          <v-card-text>
            <v-menu
              ref="menuDateOfContact"
              v-model="menuDateOfContact"
              :close-on-content-click="true"
              :return-value.sync="date"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="lastContact.dateOfContact"
                  label="Début"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="lastContact.dateOfContact"
                no-title
                scrollable
              >
              </v-date-picker>
            </v-menu>
            <v-text-field v-model="lastContact.name" label="Nom"></v-text-field>
            <v-textarea
              outlined
              label="Remarque"
              v-model="lastContact.remarks"
            ></v-textarea>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="dialog = false">
              Fermer
            </v-btn>
            <v-btn color="blue darken-1" text @click="submit()">
              Sauvegarder
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-form>
  </v-row>
</template>

<script>
import store from '@/store/index.js'
import NProgress from 'nprogress'
import moment from 'moment'

export default {
  props: {
    lastContact: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    menuDateOfContact: false,
    validEditContact: true,
    dialog: false,
    date: null
  }),

  created() {
    // Formattage des dates afin qu'elles s'affichent correctement
    this.lastContact.dateOfContact = this.formatDate(
      this.lastContact.dateOfContact
    )
  },

  methods: {
    // Sauvegarde les modifications d'un contact
    submit() {
      console.log(this.lastContact)
      if (this.$refs.formEditContact.validate()) {
        NProgress.start()
        store
          .dispatch('lastContact/editLastContact', this.lastContact)
          .then(() => {
            let contactClone = JSON.parse(JSON.stringify(this.lastContact))
            this.editData(contactClone)
            this.$refs.formCreateContact.reset()
          })
          .catch(() => {})
        this.dialog = false
        NProgress.done()
      }
    },
    // Sauvegarde les modifications d'un contact à l'entreprise
    editData(data) {
      store
        .dispatch('entreprise/editLastContact', data)
        .then(() => {})
        .catch(() => {})
    },
    formatDate: function(date) {
      return moment(date, 'YYYY-MM-DD').format('YYYY-MM-DD')
    }
  }
}
</script>
